import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CustomerServiceInvite.css';

const CustomerServiceInvite = () => (
  <div className={styles.container}>
    <p>
      If you would like to change anything within this prescription please
      contact{' '}
      <Link className={styles.link} to="/contact">
        Customer Service
      </Link>
    </p>
    <p className={styles.mayBeDifferent}>
      * Image shown may be different than actual product you receive.
    </p>
  </div>
);

export default CustomerServiceInvite;



// WEBPACK FOOTER //
// ./src/containers/CartPage/CustomerServiceInvite.jsx